import "./Earnings.css";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { useEffect, useState } from "react";
import { getTranslatedText as translate } from "../../Localization/Translation";

const Earnings = () => {
  const { locale, deliveries, setDeliveries } = useBetween(
    useSelector((state) => state.useSharedLang)
  );
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {}, [refresh]);

  const WeeklyGain = () => {
    for (let i = 0; i < deliveries.length; i++) {
      deliveries[i].Counter +=
        deliveries[i].PayToAdmin - deliveries[i].TakeFromAdmin;
      deliveries[i].PayToAdmin = 0;
      deliveries[i].TakeFromAdmin = 0;
    }
    setDeliveries(deliveries);
    setRefresh(!refresh);
  };
  const clearCounter = (index) => {
    deliveries[index].Counter = 0;
    setDeliveries(deliveries);
    setRefresh(!refresh);
  };
  let d = "-1";
  const deliveriesEarningsList = deliveries.map((Item, index) => {
    d = Number(d) + 1;
    return (
      <div
        className={
          "LaundryOwners-list animate__animated animate__fadeInUp animate__delay-" +
          d +
          "s"
        }
        key={Item.id}
        id={Item.id}
      >
        <div className="request-card row" dir="auto">
          <div
            className="col-md-4 request-card-col main-data-request-card-col"
            dir="auto"
          >
            <div className="header-join-req-card">
              <span>
                <i className="fa fa-user" aria-hidden="true"></i>
                {translate("delivery-person-name", locale)}:
              </span>
              <span>{Item.name}</span>
            </div>
          </div>
          <div className="col-md request-card-col earnings-card-col">
            <span>{translate("receivables-required", locale)}</span>
            <div>
              <span>{Item.PayToAdmin}</span>
              <span>{translate("currency-saudi", locale)}</span>
            </div>
          </div>
          <div className="col-md request-card-col earnings-card-col">
            <span>{translate("commission-due", locale)}</span>
            <div>
              <span>{Item.TakeFromAdmin}</span>
              <span>{translate("currency-saudi", locale)}</span>
            </div>
          </div>
          <div className="col-md-4 request-card-col earnings-card-col-last row">
            <div className="earnings-card-col col">
              <span>{translate("the-outcome", locale)}</span>
              <div>
                <span>{Item.Counter}</span>
                <span>{translate("currency-saudi", locale)}</span>
              </div>
            </div>
            <button
              className="btn btn-primary col"
              onClick={() => clearCounter(index)}
            >
              {translate("outcome-zeroing", locale)}
            </button>
          </div>
        </div>
      </div>
    );
  });
  const showHelp = () => {
    document.querySelector(".Info-help").style.visibility = "visible";
  };
  const hideHelp = () => {
    document.querySelector(".Info-help").style.visibility = "hidden";
  };

  return (
    <div className="Earnings main-component">
      <div className="LaundryOwners">
        <div className="header-Earnings" dir="auto">
          <div
            className="Info-help-box"
            onMouseOver={showHelp}
            onMouseOut={hideHelp}
          >
            <i className="bi bi-info-circle"></i>
          </div>
          <div className="Info-help">
            <span>
              <i className="bi bi-info-circle"></i>
              {translate("info-1", locale)}
            </span>
            <span>
              <i className="bi bi-info-circle"></i>
              {translate("info-2", locale)}
            </span>
            <span>
              <i className="bi bi-info-circle"></i>
              {translate("info-3", locale)}
            </span>
            <span>
              <i className="bi bi-info-circle"></i>
              {translate("info-4", locale)}
            </span>
            <span>
              <i className="bi bi-info-circle"></i>
              {translate("info-5", locale)}
            </span>
          </div>
          <div>
            <button className="btn btn-primary" onClick={WeeklyGain}>
              {translate("Weekly-Outcomes", locale)}
            </button>
          </div>
        </div>

        {deliveriesEarningsList}
      </div>
    </div>
  );
};

export default Earnings;
